import initTranslations from "@@/app/i18n";
import i18nConfig from "@@/i18nConfig";

export async function getSeoMeta(locale: string, page: string) {
    const ns = ["seo"];
    const { t } = await initTranslations(locale, ns);

    const seoData = t(page, { returnObjects: true });

    return {
        title: seoData.title,
        description: seoData.description,
        keywords: seoData.keywords,
        og: seoData.og || {}
    };
}